import React, { useState } from "react";
import AdminTrackingStatus from "./AdminTrackingStatus";
import RouteUsers from "./RouteUsers";
// import RouteView from "./RouteView";

import AddEditDriver from "../components/managetransportation/AddEditDriver";
import AddEditRouteLive from "./AddEditRouteLive";

function AdminLiveTracking() {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return <AdminTrackingStatus />;
      case 2:
        return <AddEditRouteLive />;
      case 3:
        return <RouteUsers />;
      case 4:
        return <AddEditDriver />;
      default:
        return <AdminTrackingStatus />;
    }
  }

  return (
    <div className="p-8">
      <div className="flex gap-6 bg-white rounded-lg overflow-x ">
        <div
          onClick={() => setStep(1)}
          className={`iskool-tab-item cursor-pointer p-4 ${
            step === 1
              ? "bg-gray-600 text-white shadow text-left "
              : "hover:bg-gray-100"
          }`}
        >
          <div className="text-lg">Tracking</div>
        </div>
        <div
          onClick={() => setStep(2)}
          className={`iskool-tab-item cursor-pointer p-4 ${
            step === 2 ? "bg-gray-600 text-white shadow" : "hover:bg-gray-100"
          }`}
        >
          <div className="text-lg">Routes Management</div>
        </div>

        <div
          onClick={() => setStep(3)}
          className={`iskool-tab-item cursor-pointer p-4 ${
            step === 3 ? "bg-gray-600 text-white shadow" : "hover:bg-gray-100"
          }`}
        >
          <div className="text-lg">Onboard</div>
        </div>

        <div
          onClick={() => setStep(4)}
          className={`iskool-tab-item cursor-pointer p-4 ${
            step === 4 ? "bg-gray-600 text-white shadow" : "hover:bg-gray-100"
          }`}
        >
          <div className="text-lg">Drivers</div>
        </div>
      </div>

      <div>{switchTab()}</div>
    </div>
  );
}

export default AdminLiveTracking;
